import React, { useCallback } from 'react';
import { type HeaderBackButtonProps } from '@react-navigation/elements';
import { type NativeStackNavigationOptions } from '@react-navigation/native-stack';

import { HeaderLeft, HeaderRight } from './components';
import { type HeaderLeftProps, type HeaderRightProps } from './Header.props';

/**
 * Returns a function, populated with the specified items,
 * which can be passed as the `headerLeft` option of a native stack navigator.
 */
export const useHeaderLeft = (
  props: HeaderLeftProps,
): NativeStackNavigationOptions['headerLeft'] => {
  return useCallback(
    (headerProps: HeaderBackButtonProps) => <HeaderLeft {...headerProps} {...props} />,
    [props],
  );
};

/**
 * Returns a function, populated with the specified items,
 * which can be passed as the `headerRight` option of a native stack navigator.
 */
export const useHeaderRight = (
  props: HeaderRightProps,
): NativeStackNavigationOptions['headerRight'] => {
  return useCallback(
    (headerProps: HeaderBackButtonProps) => <HeaderRight {...headerProps} {...props} />,
    [props],
  );
};
